import { NgModule } from '@angular/core';
import { StoreModule } from '@ngrx/store';
import { ConfigModule, StateConfig, StateTransferType } from '@spartacus/core';
import { reducerProvider, reducerToken } from './reducers';
import { SEO_FEATURE } from './seo-state';

function seoStoreConfigFactory(): StateConfig {
  // if we want to reuse CATALOG_FEATURE const in config, we have to use factory instead of plain object
  return {
    state: {
      ssrTransfer: {
        keys: { [SEO_FEATURE]: StateTransferType.TRANSFER_STATE },
      },
    },
  };
}

@NgModule({
  imports: [StoreModule.forFeature(SEO_FEATURE, reducerToken), ConfigModule.withConfigFactory(seoStoreConfigFactory)],
  providers: [reducerProvider],
})
export class SeoStoreModule {}
